import { FC, ReactNode } from "react";

import { cn } from "@/utils/styleUtils.ts";

interface Props {
    className?: string;
    children: ReactNode;
    fullScreen?: boolean;
}

const Page: FC<Props> = ({ children, className, fullScreen = false }) => {
    return (
        <div
            className={cn("flex flex-col items-center", fullScreen ? "h-screen w-screen" : "h-full w-full", className)}
        >
            {children}
        </div>
    );
};

export default Page;
